import script from "./Table.vue?vue&type=script&setup=true&lang=js"
export * from "./Table.vue?vue&type=script&setup=true&lang=js"

import "./Table.vue?vue&type=style&index=0&id=d392d764&scoped=true&lang=scss"
script.__scopeId = "data-v-d392d764"

export default script